<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  type: {
    type: String,
    default: 'base',
    validator: (value) => ['base', 'info', 'success', 'warning', 'error'].includes(value)
  }
});

// == Colors =================================
const color = computed(() => {
  const _colors = {
    base: 'bg-brand-lightGray text-brand-gray',
    success: 'bg-green-50 text-green-700',
    warning: 'bg-brand-yellow text-brand-gray',
    error: 'bg-brand-lightRed text-brand-red',
    info: 'bg-blue-50 text-blue-700'
  };
  return _colors[props.type] || _colors.base;
});
</script>

<template>
  <div class="font-sans px-8 py-4 rounded-lg" :class="color">
    <slot />
  </div>
</template>
